import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Icon } from '@hello-unicorn/client-libs';
import { filter } from 'rxjs';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';

/**
 * 레이아웃 컴포넌트
 * @description daisyUI drawer 기반의 반응형 메인 레이아웃
 * @author OOO <your-email@lepisode.team>
 */
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
  imports: [RouterOutlet, SidebarComponent, Icon, FooterComponent],
})
export class LayoutComponent {
  @ViewChild('contentArea') contentArea!: ElementRef<HTMLDivElement>;
  private router = inject(Router);

  /** 사이드바 열림 상태 */
  readonly isSidebarOpen = signal(
    typeof window !== 'undefined' ? window.innerWidth >= 1024 : true
  );

  /** 사이드바 토글 */
  toggleSidebar() {
    this.isSidebarOpen.update(v => !v);
  }

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.contentArea) {
          this.contentArea.nativeElement.scrollTop = 0;
        }
      });
  }

  /**
   * 창 크기 변경 감지
   * 모바일에서 데스크탑으로 전환 시 사이드바 자동 표시
   */
  @HostListener('window:resize')
  onResize() {
    const isDesktop = window.innerWidth >= 1024; // lg breakpoint
    if (isDesktop && !this.isSidebarOpen()) {
      this.isSidebarOpen.set(true);
    }
  }
}
